import loadable from '@loadable/component';
import { tw } from '@careinfo/tailwind';
import APIS from '../../constant/EndPoint';
import usePostHook from '../../customHooks/usePostHook';
import { useParams } from 'react-router-dom';
import useGetHook from '../../customHooks/useGetHook';
import Spinner from '../../components/Reusable/Spinner';
const StatusListComponent = loadable(
  () => import('../../components/Status/StatusList')
);

const StatusList = () => {
  const { slug } = useParams<{ slug: string }>();
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [`status-${slug}`],
  });

  const handleAsync = async () => {
    const url = `${APIS.DELIVERY_PARTNER}${slug}/sync-status/`;
    const formData = {};
    try {
      await mutateAsync({ url, formData, setError: () => { } });
    } catch (err) {
      console.error(err);
    }
  };

  const { data, isLoading } = useGetHook({
    queryKey: [`status-${slug}`],
    url: `${APIS.DELIVERY_PARTNER}${slug}/status/`,
    params: {},
  });

  return isLoading ? (
    <Spinner />
  ) : (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-4 uppercase font-extrabold items-center`}
      >
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Status</span>
      </div>
      <StatusListComponent
        handleAsync={handleAsync}
        isLoading={isPostLoading}
        slug={slug}
        statusData={data?.results}
      />
    </div>
  );
};

export default StatusList;
